<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <b-modal
        id="modal-upload"
        title="آپلود مدیا"
        centered
        ok-only
        ok-title="بستن"
    >
      <b-form>
        <b-button
            class="mt-2 col-12 col-md-4"
            variant="warning"
            @click="$refs.refInputEl3.click()"
        >
          <input
              ref="refInputEl3"
              type="file"
              class="d-none"
              @change="select"
          >
          <span class="">بارگذاری</span>
        </b-button>
        <b-button
            variant="primary"
            class="mt-2 mb-sm-0 ml-2 col-12 col-md-2"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            @click="uploadSubMedia"
        >
          ثبت
        </b-button>
      </b-form>
      <b-progress
          v-if="uploaded2 !== 0 && uploaded2 !== 100"
          :value="uploaded2"
          max="100"
          variant="primary"
          class=" mt-2"
      />

      <b-alert
          :show="done === true"
          variant="success"
          class="col-12"
      >
        <div class="alert-body mt-2">
          <feather-icon
              class="mr-25"
              icon="CheckIcon"
          />
          <span class="ml-25">فایل شما آپلود شده است.</span>
        </div>
      </b-alert>
      <b-alert
          :show="errorAlert"
          variant="danger"
          class="col-12"
      >
        <div class="alert-body mt-2">
          <feather-icon
              class="mr-25"
              icon="CloseIcon"
          />
          <span class="ml-25">آپلود فایل با مشکل مواجه شد!</span>
        </div>
      </b-alert>
    </b-modal>
    <div v-if="medias">
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-form>
              <b-row>
                <!-- Field: fileData -->
                <b-col
                    cols="12"
                >
                  <h2>بارگذاری مدیای جدید</h2>

                  <b-button
                      class="mt-2 col-12 col-md-4"
                      variant="warning"
                      @click="$refs.refInputEl2.click()"
                  >
                    <input
                        ref="refInputEl2"
                        type="file"
                        class="d-none"
                        @change="select"
                    >
                    <span class="">بارگذاری</span>
                  </b-button>
                  <b-button
                      variant="primary"
                      class="mt-2 mb-sm-0 ml-2   col-12 col-md-2"
                      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                      @click="upload"
                  >
                    ثبت
                  </b-button>

                  <b-alert
                      :show="true"
                      variant="warning"
                      class="col-md-6 col-12"
                  >
                    <div class="alert-body mt-2">
                      <feather-icon
                          class="mr-25"
                          icon="CheckIcon"
                      />
                      <span class="ml-25">توجه : اگر مدیای مورد نظر شما برای آپلود ویدیو میباشد به صورت پیشفرض با کیفیت 1080 ثبت میشود.</span>
                    </div>
                  </b-alert>
                </b-col>
              </b-row>
            </b-form>

            <b-progress
                v-if="uploaded !== 0 && uploaded !== 100"
                :value="uploaded"
                max="100"
                variant="primary"
                class=" mt-2"
            />

            <b-alert
                :show="done === true"
                variant="success"
                class="col-md-2 col-12"
            >
              <div class="alert-body mt-2">
                <feather-icon
                    class="mr-25"
                    icon="CheckIcon"
                />
                <span class="ml-25">فایل شما آپلود شده است.</span>
              </div>
            </b-alert>
            <b-alert
                :show="errorAlert"
                variant="danger"
                class="col-md-2 col-12"
            >
              <div class="alert-body mt-2">
                <feather-icon
                    class="mr-25"
                    icon="CloseIcon"
                />
                <span class="ml-25">آپلود فایل با مشکل مواجه شد!</span>
              </div>
            </b-alert>
          </b-card>

          <div v-if="productType == 2 || productType == 5 || productType == 8 || productType == 9" class="w-100">
            <b-card v-if="medias.videos.length > 0">
              <b-row class="px-2">

                <h3>ویدیو</h3>

                <div class="row mt-5">
                  <video
                      preload="none"
                      class="col-12"
                      controls
                      style="max-height: 30rem;"
                  >
                    <source
                        size=""
                        :src="`${baseURL}media/file/video/`+medias.videos[0].pictureUrl"
                        type=""
                    />
                  </video>
                  <b-button
                      class="m-2"
                      variant="danger"
                      v-b-modal.modal-delete
                      @click="showModal(medias.videos[0].pictureUrl)"
                  >
                    <feather-icon icon="TrashIcon" size="20" class=""/>
                  </b-button>

                  <b-button
                      class="m-2"
                      variant="primary"
                      @click="showChangeNameModal(medias.videos[0].mediaId,medias.videos[0].title.split('.')[0])"
                      v-b-modal.modal-edit-name
                  >
                    <feather-icon icon="EditIcon" size="20"/>
                  </b-button>

                  <b-button
                      class="m-2"
                      variant="success"
                      v-b-modal.modal-edit-priority
                      @click="showChangePriorityModal(medias.videos[0].mediaId,medias.videos[0].priority)"
                  >
                    <feather-icon icon="AlignCenterIcon" size="20"/>
                  </b-button>
                </div>

              </b-row>
            </b-card>
            <b-card v-if="productType == 8">
              <b-col cols="12">
                <b-form-group
                    class="mb-2"
                    label="توضیحات"
                    label-for="product-content"
                >
                  <ckEditorMain ref="editorContent" @getEditorContent="setEditorContent"
                                :defaultContent="testDescription"></ckEditorMain>
                </b-form-group>
                <b-button
                    class="m-2"
                    variant="primary"
                    @click="setTestDescription()"
                >
                  ویرایش
                </b-button>
              </b-col>
            </b-card>
          </div>

          <div v-if="productType == 1 || productType == 3 || productType == 4 || productType == 6">
            <section v-if="medias.videos.length > 0" id="card-navigation">
              <b-row v-for="(video,item) in medias.videos">
                <!-- pill tabs inside card -->
                <b-col v-if="video.parentId === 0 || video.parentId === null" md="12">
                  <b-card class="text-center">
                    <b-tabs
                        pills
                        nav-class="mb-3"
                    >
                      <b-tab
                          title="1080"
                          active
                      >
                        <app-collapse accordion class="col-12">
                          <app-collapse-item :title="video.title.split('.')[0]">
                            <video
                                preload="none"
                                class="col-12"
                                controls
                                style="max-height: 30rem;"
                            >
                              <source
                                  size=""
                                  :src="`${baseURL}media/file/video/`+video.pictureUrl"
                                  type=""
                              />
                            </video>

                            <b-button
                                v-if="video.arvanCloudVideoId === null"
                                class="m-2"
                                variant="info"
                                @click="arvanObj.mediaId = video.mediaId"
                                v-b-modal.modal-arvan
                            >
                              <feather-icon icon="UnlockIcon" size="20" class=""/>
                            </b-button>

                            <b-button
                                v-else
                                class="m-2"
                                variant="info"
                            >
                              <span v-if="video.aravanStatus === 'queue_download'">در صف دانلود ابرآروان</span>
                              <span v-if="video.aravanStatus === 'queue_convert'">در صف تبدیل</span>
                              <span v-if="video.aravanStatus === 'converting'">در حال تبدیل</span>
                              <span @click="arvanObj.mediaId = video.mediaId" v-b-modal.modal-arvan
                                    v-if="video.aravanStatus && video.aravanStatus.toLowerCase && video.aravanStatus.toLowerCase().includes('fail')">
                                <feather-icon icon="UnlockIcon" size="20" class=""/>
                                 آپلود با مشکل مواجه شده دوباره تلاش کنید
                              </span>
                              <span v-if="video.aravanStatus === 'complete'">
                                  <feather-icon icon="LockIcon" size="20" class=""/>
                                  <span class="ml-1">محافظت شده</span>
                              </span>
                            </b-button>

                            <b-button
                                class="m-2"
                                variant="danger"
                                v-b-modal.modal-video-delete
                                @click="tempVideoObject = video"
                            >
                              <feather-icon icon="TrashIcon" size="20" class=""/>
                            </b-button>

                            <b-button
                                class="m-2"
                                variant="primary"
                                @click="showChangeNameModal(video.mediaId,video.title.split('.')[0])"
                                v-b-modal.modal-edit-name
                            >
                              <feather-icon icon="EditIcon" size="20"/>
                            </b-button>

                            <b-button
                                class="m-2"
                                variant="success"
                                v-b-modal.modal-edit-priority
                                @click="showChangePriorityModal(video.mediaId,video.priority)"
                            >
                              <feather-icon icon="AlignCenterIcon" size="20"/>
                            </b-button>

                            <b-button
                                class="m-2"
                                variant="warning"
                                v-b-modal.modal-edit-type
                                @click="selectMediaForMediaGroup(video.mediaId,video.mediaGroupType)"
                            >
                              <feather-icon icon="BookOpenIcon" size="20"/>
                            </b-button>

                            <b-button
                                class="m-2"
                                variant="secondary"
                                v-b-modal.modal-edit-isReachable
                                @click="selectMediaForIsReachable(video.mediaId,video.isReachable)"
                            >
                              <feather-icon icon="SlashIcon" size="20"/>
                            </b-button>
                          </app-collapse-item>
                        </app-collapse>
                      </b-tab>

                      <b-tab title="720">
                        <template v-for="mv in medias.videos">
                          <app-collapse v-if="mv.parentId === video.mediaId && mv.quality === 2" accordion
                                        class="col-12">
                            <app-collapse-item :title="mv.title.split('.')[0]">
                              <video
                                  preload="none"
                                  class="col-12"
                                  controls
                                  style="max-height: 30rem;"
                              >
                                <source
                                    size=""
                                    :src="baseURL+'media/file/video/'+mv.pictureUrl"
                                    type=""
                                />
                              </video>
                              <b-button
                                  class="m-2"
                                  variant="danger"
                                  v-b-modal.modal-delete
                                  @click="showModal(mv.pictureUrl)"
                              >
                                <feather-icon icon="TrashIcon" size="20" class=""/>
                              </b-button>

                              <b-button
                                  class="m-2"
                                  variant="primary"
                                  @click="showChangeNameModal(mv.mediaId,mv.title.split('.')[0])"
                                  v-b-modal.modal-edit-name
                              >
                                <feather-icon icon="EditIcon" size="20"/>
                              </b-button>

                              <b-button
                                  class="m-2"
                                  variant="success"
                                  v-b-modal.modal-edit-priority
                                  @click="showChangePriorityModal(mv.mediaId,mv.priority)"
                              >
                                <feather-icon icon="AlignCenterIcon" size="20"/>
                              </b-button>

                              <b-button
                                  class="m-2"
                                  variant="warning"
                                  v-b-modal.modal-edit-type
                                  @click="selectMediaForMediaGroup(mv.mediaId,mv.mediaGroupType)"
                              >
                                <feather-icon icon="BookOpenIcon" size="20"/>
                              </b-button>

                              <b-button
                                  class="m-2"
                                  variant="secondary"
                                  v-b-modal.modal-edit-isReachable
                                  @click="selectMediaForIsReachable(mv.video.mediaId,mv.video.isReachable)"
                              >
                                <feather-icon icon="SlashIcon" size="20"/>
                              </b-button>
                            </app-collapse-item>
                          </app-collapse>
                        </template>

                        <b-button
                            class="m-2"
                            variant="warning"
                            v-b-modal.modal-upload
                            @click="setUploadParentId(video.mediaId,2)"
                        >
                          آپلود ویدیو (کیفیت 720)
                        </b-button>
                      </b-tab>

                      <b-tab title="480">
                        <template v-for="mv in medias.videos">
                          <app-collapse v-if="mv.parentId === video.mediaId && mv.quality === 3" accordion
                                        class="col-12">
                            <app-collapse-item :title="mv.title.split('.')[0]">
                              <video
                                  preload="none"
                                  class="col-12"
                                  controls
                                  style="max-height: 30rem;"
                              >
                                <source
                                    size=""
                                    :src="baseURL+'media/file/video/'+mv.pictureUrl"
                                    type=""
                                />
                              </video>
                              <b-button
                                  class="m-2"
                                  variant="danger"
                                  v-b-modal.modal-delete
                                  @click="showModal(mv.pictureUrl)"
                              >
                                <feather-icon icon="TrashIcon" size="20" class=""/>
                              </b-button>

                              <b-button
                                  class="m-2"
                                  variant="primary"
                                  @click="showChangeNameModal(mv.mediaId,mv.title.split('.')[0])"
                                  v-b-modal.modal-edit-name
                              >
                                <feather-icon icon="EditIcon" size="20"/>
                              </b-button>

                              <b-button
                                  class="m-2"
                                  variant="success"
                                  v-b-modal.modal-edit-priority
                                  @click="showChangePriorityModal(mv.mediaId,mv.priority)"
                              >
                                <feather-icon icon="AlignCenterIcon" size="20"/>
                              </b-button>

                              <b-button
                                  class="m-2"
                                  variant="warning"
                                  v-b-modal.modal-edit-type
                                  @click="selectMediaForMediaGroup(mv.mediaId,mv.mediaGroupType)"
                              >
                                <feather-icon icon="BookOpenIcon" size="20"/>
                              </b-button>

                              <b-button
                                  class="m-2"
                                  variant="secondary"
                                  v-b-modal.modal-edit-isReachable
                                  @click="selectMediaForIsReachable(mv.video.mediaId,mv.video.isReachable)"
                              >
                                <feather-icon icon="SlashIcon" size="20"/>
                              </b-button>
                            </app-collapse-item>
                          </app-collapse>
                        </template>
                        <b-button
                            class="m-2"
                            variant="warning"
                            v-b-modal.modal-upload
                            @click="setUploadParentId(video.mediaId,3)"
                        >
                          آپلود ویدیو (کیفیت 480)
                        </b-button>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </b-col>
              </b-row>
            </section>

            <b-card v-if="medias.podcasts.length > 0">
              <b-row class="px-2">

                <h3>پادکست ها</h3>
                <app-collapse accordion class="col-12">

                  <app-collapse-item v-for="(podcast,item) in medias.podcasts" :title="podcast.title.split('.')[0]">
                    <audio class="col-12" preload="none" controls crossorigin playsinline>
                      <source
                          :src="baseURL+'media/file/podcast/'+podcast.pictureUrl"
                          type=""
                      />
                    </audio>
                    <b-button
                        class="m-2"
                        variant="danger"
                        v-b-modal.modal-delete
                        @click="showModal(podcast.pictureUrl)"
                    >
                      <feather-icon icon="TrashIcon" size="20" class=""/>
                    </b-button>

                    <b-button
                        class="m-2"
                        variant="primary"
                        @click="showChangeNameModal(podcast.mediaId,podcast.title.split('.')[0])"
                        v-b-modal.modal-edit-name
                    >
                      <feather-icon icon="EditIcon" size="20"/>
                    </b-button>

                    <b-button
                        class="m-2"
                        variant="success"
                        v-b-modal.modal-edit-priority
                        @click="showChangePriorityModal(podcast.mediaId,podcast.priority)"
                    >
                      <feather-icon icon="AlignCenterIcon" size="20"/>
                    </b-button>

                    <b-button
                        class="m-2"
                        variant="warning"
                        v-b-modal.modal-edit-type
                        @click="selectMediaForMediaGroup(podcast.mediaId,podcast.mediaGroupType)"
                    >
                      <feather-icon icon="BookOpenIcon" size="20"/>
                    </b-button>

                    <b-button
                        class="m-2"
                        variant="secondary"
                        v-b-modal.modal-edit-isReachable
                        @click="selectMediaForIsReachable(podcast.mediaId,podcast.isReachable)"
                    >
                      <feather-icon icon="SlashIcon" size="20"/>
                    </b-button>
                  </app-collapse-item>

                </app-collapse>

              </b-row>
            </b-card>

            <b-card v-if="medias.images.length > 0">
              <b-row class="px-2">

                <h3>عکس ها</h3>
                <app-collapse accordion class="col-12">

                  <div class="row ">

                    <div v-for="(image,index) in medias.images" class="col-md-4 mt-3">

                      <img class="col-12" style="height: 400px"
                           :src="baseURL+'media/file/picture/'+image.pictureUrl" alt="profile">
                      <b-button
                          class="col-4 m-2"
                          variant="danger"
                          v-b-modal.modal-delete
                          @click="showModal(image.pictureUrl)"
                      >
                        <feather-icon icon="TrashIcon" size="20" class=""/>
                      </b-button>

                      <b-button
                          class="col-4 m-2"
                          variant="success"
                          v-b-modal.modal-edit-priority
                          @click="showChangePriorityModal(image.mediaId,image.priority)"
                      >
                        <feather-icon icon="AlignCenterIcon" size="20"/>
                      </b-button>

                      <b-button
                          class="m-2"
                          variant="warning"
                          v-b-modal.modal-edit-type
                          @click="selectMediaForMediaGroup(image.mediaId,image.mediaGroupType)"
                      >
                        <feather-icon icon="BookOpenIcon" size="20"/>
                      </b-button>

                      <b-button
                          class="m-2"
                          variant="secondary"
                          v-b-modal.modal-edit-isReachable
                          @click="selectMediaForIsReachable(image.mediaId,image.isReachable)"
                      >
                        <feather-icon icon="SlashIcon" size="20"/>
                      </b-button>
                    </div>
                  </div>
                </app-collapse>
              </b-row>
            </b-card>

            <b-card v-if="medias.pdFs.length > 0">
              <b-row class="px-2">

                <h3>فایل ها</h3>
                <div v-for="(file,index) in medias.pdFs" class="col-12">

                  <div class="row ">
                    <div class="col-md-4 mt-3">

                      <a class="d-block" :href="baseURL+'media/file/pdf/'+file.pictureUrl" download
                         target="_blank">{{ file.title.split('.')[0] }}</a>

                      <b-button
                          class=""
                          variant="danger"
                          v-b-modal.modal-delete
                          @click="showModal(file.pictureUrl)"
                      >
                        <feather-icon icon="TrashIcon" size="20" class=""/>
                      </b-button>

                      <b-button
                          class="m-2"
                          variant="primary"
                          @click="showChangeNameModal(file.mediaId,file.title.split('.')[0])"
                          v-b-modal.modal-edit-name
                      >
                        <feather-icon icon="EditIcon" size="20"/>
                      </b-button>

                      <b-button
                          class=""
                          variant="success"
                          v-b-modal.modal-edit-priority
                          @click="showChangePriorityModal(file.mediaId,file.priority)"
                      >
                        <feather-icon icon="AlignCenterIcon" size="20"/>
                      </b-button>

                      <b-button
                          class="m-2"
                          variant="warning"
                          v-b-modal.modal-edit-type
                          @click="selectMediaForMediaGroup(file.mediaId,file.mediaGroupType)"
                      >
                        <feather-icon icon="BookOpenIcon" size="20"/>
                      </b-button>

                      <b-button
                          class="m-2"
                          variant="secondary"
                          v-b-modal.modal-edit-isReachable
                          @click="selectMediaForIsReachable(file.mediaId,file.isReachable)"
                      >
                        <feather-icon icon="SlashIcon" size="20"/>
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-row>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-modal
        id="modal-delete"
        centered
        ok-title="حذف"
        cancelTitle="انصراف"
        @ok="deleteMedia(deleteItem)"
    >
      <span>حذف شود؟</span>
    </b-modal>
    <b-modal
        id="modal-edit-name"
        title="ویرایش نام فایل"
        centered
        ok-title="ثبت"
        cancelTitle="انصراف"
        @ok="updateMediaName"
    >
      <input @keydown.enter="updateMediaName" type="text" v-model="newName">
    </b-modal>
    <b-modal
        id="modal-edit-priority"
        title="ویرایش اولویت فایل"
        centered
        ok-title="ثبت"
        cancelTitle="انصراف"
        @ok="updateMediaPriority"
    >
      <input @keydown.enter="updateMediaPriority" type="number" v-model="newPriority">
    </b-modal>
    <b-modal
        id="modal-edit-type"
        title="ویرایش دسته بندی فایل"
        centered
        ok-title="ثبت"
        cancelTitle="انصراف"
        no-close-on-backdrop
        @ok="updateMediaGroupType"
    >
      <b-row>
        <b-col cols="12">
          <span>دسته بندی ها :</span>
          <b-form-group
              label-cols="12"
          >
            <v-select
                class="mt-1"
                v-model="selectedTypeForMediaGroup"
                :clearable="false"
                label="option"
                :options="mediaGroupTypes"
                :reduce="option => option.value"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
        id="modal-arvan"
        title="محافظت از فایل"
        centered
        ok-title="ثبت"
        cancelTitle="انصراف"
        @ok="arvanCreate"
    >
      <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
      >
        <b-row>
          <span class="mx-1 mb-1">عنوان :</span>
          <b-col cols="12">
            <validation-provider
                name="title"
                rules="required"
            >
              <b-form-input id="title" v-model="arvanObj.title" class="form-control"></b-form-input>
            </validation-provider>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal
        id="modal-edit-isReachable"
        title="ویرایش دسترسی کاربران به فایل"
        centered
        ok-title="ثبت"
        cancelTitle="انصراف"
        no-close-on-backdrop
        @ok="setReachableMedia"
    >
      <b-row>
        <b-col cols="12">
          <span>انتخاب دسترسی :</span>
          <b-form-group
              label-cols="12"
          >
            <v-select
                class="mt-1"
                v-model="selectedIsReachableType"
                :clearable="false"
                label="option"
                :options="ReachableTypes"
                :reduce="option => option.value"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
        id="modal-video-delete"
        centered
        ok-title="حذف"
        cancelTitle="انصراف"
        @ok="sendMediaRemoveRequest()"
    >
      <span>حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BAlert,
  BButton,
  BCard,
  BCol,
  BForm, BFormGroup, BFormInput, BOverlay,
  BRow, BTab, BTabs, BProgress, BModal
} from "bootstrap-vue";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import vSelect from "vue-select";
import axios from "axios";
import {getUserData} from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  ProductGetProductsMediasForAdminRequest,
  ProductSetMediaGroupTypeRequest,
  ProductSetReachableRequest, PsychologicalTestGetByProductId, UpdateResultDescription
} from "@/libs/Api/Product";
import {MediaDeleteByPictureUrlRequest} from "@/libs/Api/Product";
import {MediaChangeMediaNameRequest, MediaChangePriorityRequest} from "@/libs/Api/Media";
import Helper from "@/libs/Helper";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {ArvanCloudVideoCreateRequest, DeleteArvanVideo} from "@/libs/Api/ArvanCloud";
import ckEditorMain from "@/views/components/ckEditorMain.vue";

export default {
  title: 'مدیای محصول - پنل ادمین لنزآوا',
  name: "ECommerceAddProductMedia",
  components: {
    ckEditorMain,
    BCard,
    BRow,
    BCol,
    BButton,
    BAlert,
    BTab,
    BTabs,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BProgress,
    BModal,
    AppCollapse,
    AppCollapseItem,
    vSelect,
    ValidationProvider, ValidationObserver
  },
  data() {
    return {
      productId: this.$route.params.id,
      productType: this.$route.query.productType,
      userToken: getUserData().token,
      medias: null,
      errorAlert: false,
      done: null,
      overlay: true,
      deleteItem: null,
      baseURL: Helper.baseUrl,
      types: [
        {name: 'دوره', value: 1},
        {name: 'لایو', value: 2},
        {name: 'فایل', value: 3},
        {name: 'پادکست', value: 4},
        {name: 'پست آموزشی', value: 5},
        {name: 'استوری', value: 9},
      ],
      file: null,
      chunks: [],
      uploaded: 0,
      uploaded2: 0,
      namePictureURL: null,
      priorityPictureURL: null,
      newName: '',
      newPriority: '',
      uploadParentId: null,
      quality: null,
      selectedMediaIdForMediaGroup: null,
      selectedTypeForMediaGroup: null,
      tempVideoObject: null,
      temptest: null,
      mediaGroupTypes: [
        {
          option: 'ویدئو جلسات',
          value: 1
        },
        {
          option: 'ویس جلسات',
          value: 2
        },
        {
          option: 'معرفی',
          value: 3
        },
        {
          option: 'تمرین',
          value: 4
        },
        {
          option: 'کلیپ',
          value: 5
        },
        {
          option: 'پادکست',
          value: 6
        },
        {
          option: 'فرمول',
          value: 7
        },
        {
          option: 'کادر طلایی',
          value: 8
        },
        {
          option: 'فایل',
          value: 9
        },
      ],
      arvanObj: {
        title: '',
        description: '',
        mediaId: null
      },
      selectedIsReachableType: null,
      testDescription: '',
      selectedMediaIdForIsReachableType: null,
      ReachableTypes: [
        {
          option: 'قابل دسترسی',
          value: true
        },
        {
          option: 'غیر قابل دسترسی',
          value: false
        },
      ]
    };
  },
  async created() {
    await this.getProductMedias();
    if (this.productType == 8) {
      await this.getTestDescription();
    }
  },
  computed: {
    formData() {
      let formData = new FormData;

      if (this.file !== null) {
        // formData.set('is_last', this.chunks.length === 1);
        // formData.set('file', this.chunks[0], `${this.file.name}`);
        formData.set('file', this.file, `${this.file.name}`);
      }
      return formData;
    },
    config() {
      return {
        method: 'POST',
        data: this.chunksFormData,
        withCredentials: true,
        url: Helper.baseUrl
            + 'api/Product/UploadFile?productId='
            + this.productId
            + '&productType='
            + this.productType
            + '&quality=' + 1,
        headers: {
          "Content-Type": "multipart/form-data",
          'Authorization': this.userToken,
          'Token': this.userToken,
        },
        onUploadProgress: progressEvent => {
          this.uploaded = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      };
    },
    config2(parentId, quality) {
      return {
        method: 'POST',
        data: this.formData,
        withCredentials: true,
        url: Helper.baseUrl
            + 'api/Product/UploadFile?productId='
            + this.productId + '&productType='
            + this.productType + '&quality='
            + this.quality + '&parentId='
            + this.uploadParentId,
        headers: {
          "Content-Type": "multipart/form-data",
          'Authorization': this.userToken,
          'Token': this.userToken,
        },
        onUploadProgress: progressEvent => {
          this.uploaded2 = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      };
    },
  },
  methods: {
    generateFileId() {
      return Date.now().toString(36) + Math.random().toString(36).substr(2);
    },
    upload() {
      this.overlay = true;
      axios(this.config).then(response => {

        if (response.data.isSuccess === false) {
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات ناموفق`,
              icon: 'CheckIcon',
              variant: 'danger',
              text: response.data.errorMessage,
            },
          })
          this.overlay = false;
          this.errorAlert = true;
        } else {
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات موفق`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `فایل با موفقیت آپلود شد.`,
            },
          })
          this.overlay = false;
          this.done = true;
          this.getProductMedias()
        }
      }).catch(error => {
        this.overlay = false;
        this.errorAlert = true;
        console.log(error);
      });
    },
    async getProductMedias() {
      let _this = this;
      _this.overlay = true

      let productGetProductsMediasRequest = new ProductGetProductsMediasForAdminRequest(_this);
      productGetProductsMediasRequest.setId(_this.productId)
      await productGetProductsMediasRequest.fetch(function (content) {
        _this.overlay = false;
        _this.medias = content;
      }, function (content) {
        _this.overlay = false;
      });
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param
    },
    showChangeNameModal(param1, param2) {
      let _this = this;
      _this.namePictureURL = param1;
      _this.newName = param2
    },
    showChangePriorityModal(param1, priority) {
      let _this = this;
      _this.priorityPictureURL = param1;
      _this.newPriority = priority;
    },
    select(event) {
      this.file = event.target.files.item(0);
    },
    uploadSubMedia() {
      let _this = this;
      let videos = _this.medias.videos;
      let passage = true;
      videos.find(el => {
        if (el.parentId === _this.uploadParentId && el.quality === _this.quality) {
          passage = false;
          return _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `توجه`,
              icon: 'CloseIcon',
              variant: 'danger',
              text: `ویدیویی با کیفیت مورد نظر شما موجود است , برای بارگذاری ویدیو جدید ابتدا باید ویدیو قبلی را حذف کنید.`,
            },
          })
        }
      })
      if (passage === true) {
        _this.overlay = true;
        axios(_this.config2).then(response => {
          if (response.data.isSuccess === false) {
            _this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: `عملیات ناموفق`,
                icon: 'CheckIcon',
                variant: 'danger',
                text: response.data.errorMessage,
              },
            })
            _this.overlay = false;
            _this.errorAlert = true;
          } else {
            _this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: `عملیات موفق`,
                icon: 'CheckIcon',
                variant: 'success',
                text: `فایل با موفقیت آپلود شد.`,
              },
            })
            _this.overlay = false;
            _this.done = true;
            window.location.reload();
          }
        }).catch(error => {
          _this.overlay = false;
          _this.errorAlert = true;
          console.log(error);
        });
      }
    },
    async deleteMedia(param) {
      let _this = this;
      _this.overlay = true

      let mediaDeleteByPictureUrlRequest = new MediaDeleteByPictureUrlRequest(_this);
      mediaDeleteByPictureUrlRequest.setSocialMediaId(param);
      await mediaDeleteByPictureUrlRequest.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `حذف شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عملیات انجام نشد.`,
          },
        })
      })
    },
    async updateMediaName() {
      let _this = this;
      _this.overlay = true

      let data = {
        socialMediaId: _this.namePictureURL,
        newName: _this.newName
      }

      let mediaChangeMediaNameRequest = new MediaChangeMediaNameRequest(_this);
      mediaChangeMediaNameRequest.setParams(data);
      await mediaChangeMediaNameRequest.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عملیات انجام نشد.`,
          },
        })
      })
    },
    setUploadParentId(id, q) {
      let _this = this;
      _this.uploadParentId = id;
      _this.quality = q;
    },
    async updateMediaPriority() {
      let _this = this;
      _this.overlay = true

      let data = {
        socialMediaId: _this.priorityPictureURL,
        priority: _this.newPriority
      }

      let mediaChangePriorityRequest = new MediaChangePriorityRequest(_this);
      mediaChangePriorityRequest.setParams(data);
      await mediaChangePriorityRequest.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عملیات انجام نشد.`,
          },
        })
      })
    },
    selectMediaForMediaGroup(mediaId, type) {
      this.selectedMediaIdForMediaGroup = mediaId;
      this.selectedTypeForMediaGroup = type;
    },
    selectMediaForIsReachable(mediaId, type) {
      this.selectedMediaIdForIsReachableType = mediaId;
      this.selectedIsReachableType = type;
    },
    async updateMediaGroupType() {
      let _this = this;
      _this.overlay = true

      let data = {
        mediaId: _this.selectedMediaIdForMediaGroup,
        type: _this.selectedTypeForMediaGroup
      }

      let productSetMediaGroupTypeRequest = new ProductSetMediaGroupTypeRequest(_this);
      productSetMediaGroupTypeRequest.setParams(data);
      await productSetMediaGroupTypeRequest.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عملیات انجام نشد.`,
          },
        })
      })
    },
    async arvanCreate() {
      let _this = this;
      _this.overlay = true;

      if (_this.arvanObj.title.length === 0) {
        return _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عنوان فایل الزامی است.`,
          },
        })
      }

      let arvanCloudVideoCreateRequest = new ArvanCloudVideoCreateRequest(_this);
      arvanCloudVideoCreateRequest.setParams(_this.arvanObj);
      await arvanCloudVideoCreateRequest.fetch(function (content) {
        _this.overlay = false
        if (content.isSuccess) {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات موفق`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `درخواست شما ارسال شد.`,
            },
          })
        } else {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات ناموفق`,
              icon: 'CloseIcon',
              variant: 'danger',
              text: `عملیات انجام نشد.`,
            },
          })
        }
        window.location.reload();
      }, function (error) {
        _this.overlay = false
      })
    },
    async deleteVideoMedia() {
      let _this = this;
      _this.overlay = true

      let mediaDeleteByPictureUrlRequest = new MediaDeleteByPictureUrlRequest(_this);
      mediaDeleteByPictureUrlRequest.setSocialMediaId(_this.tempVideoObject.pictureUrl);
      await mediaDeleteByPictureUrlRequest.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `حذف شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عملیات انجام نشد.`,
          },
        })
      })
    },
    async sendMediaRemoveRequest() {
      if (!this.tempVideoObject || !this.tempVideoObject.arvanCloudVideoId) {
        try {
          await this.deleteVideoMedia()
        } catch (error) {
          console.error(error);
        } finally {
          this.overlay = false;
        }
      } else {
        // console.log('here')
        await this.sendDeleteArvanVideo();
      }
    },
    async sendDeleteArvanVideo() {
      try {
        this.overlay = true;
        let _this = this;
        let deleteArvanVideo = new DeleteArvanVideo(_this);
        deleteArvanVideo.setRequestParam({
          videoId: _this.tempVideoObject.arvanCloudVideoId,
        });
        await deleteArvanVideo.fetch((response) => {
          if (response.isSuccess) {
            _this.deleteVideoMedia();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
      }
    },
    async setReachableMedia() {
      let _this = this;
      _this.overlay = true

      let data = {
        mediaId: _this.selectedMediaIdForIsReachableType,
        isReachable: _this.selectedIsReachableType
      }

      let productSetReachableRequest = new ProductSetReachableRequest(_this);
      productSetReachableRequest.setParams(data);
      await productSetReachableRequest.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عملیات انجام نشد.`,
          },
        })
      })
    },
    async getTestDescription() {
      let _this = this;
      _this.overlay = true

      let data = {
        productId: _this.productId,
      }

      let psychologicalTestGetByProductId = new PsychologicalTestGetByProductId(_this);
      psychologicalTestGetByProductId.setParams(data);
      await psychologicalTestGetByProductId.fetch(function (content) {
        _this.overlay = false
        _this.temptest = content.data;
        console.log(_this.temptest)
        _this.testDescription = content.data.resultDescription;
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عملیات انجام نشد.`,
          },
        })
      })
    },
    async setTestDescription() {
      let _this = this;
      _this.overlay = true

      let data = {
        id: _this.temptest.id,
        resultDescription: _this.testDescription
      }

      let updateResultDescription = new UpdateResultDescription(_this);
      updateResultDescription.setParams(data);
      await updateResultDescription.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عملیات انجام نشد.`,
          },
        })
      })
    },
    setEditorContent(content) {
      this.testDescription = content;
    },
  }
}
</script>

<style scoped>

</style>
